import styled from 'styled-components';

export const ModalContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FiscalInfoLabel = styled.div`
  width: 100%;
  border-radius: 12px;
  padding: 12px 14px;
  background: ${({ theme }) => theme.neutral900};
  border: 1px solid ${({ theme }) => theme.neutral800};
`;
